<template>
  <a-spin size="large" :spinning="loading">
    <div class="main-box">
      <div class="header">
        <span class="backer" @click="backHandler"
          ><a-icon type="left" class="icon" />{{ $t("stepBack") }}</span
        >
        <a-button class="publish" type="primary" @click="publish">{{
          $t("Publish")
        }}</a-button>
        <div class="title" :class="[lang]">
          <a-icon
            type="robot"
            class="icon"
            :style="{ 'margin-left': lang == 'AR' ? '5px' : 0 }"
          />
          {{ $t("RealTimeDialogue") }}
        </div>
        <div class="subtitle" :class="[lang]">
          {{ $t("Conversedirectlywith") }}
        </div>
      </div>
      <div
        class="dialogWind"
        :style="{
          maxHeight: maxWindowHeight + 'px',
          minHeight: maxWindowHeight + 'px',
        }"
      >
        <simplebar
          data-simplebar-auto-hide="true"
          class="simplebarWrap-dialog"
          ref="scrollContainer"
          :scrollbarMaxSize="50"
          :style="{
            maxHeight: maxWindowHeight + 'px',
          }"
        >
          <div>
            <div class="talkWind">
              <div class="wrap-message">
                <ul>
                  <li class="leftTalk" v-if="initTips">
                    <div class="box">
                      <img src="@/assets/img/robot.png" alt="" />
                      <div class="wrap-info">
                        <div class="message">
                          <div
                            class="messageText"
                            v-html="formatText(initTips)"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div style="clear: both"></div>
                  </li>

                  <li
                    v-for="(item, index) in dialogList"
                    :key="index"
                    :class="{
                      rightTalk: item.role_type == 1 ? true : false,
                      leftTalk: item.role_type == 0 ? true : false,
                    }"
                  >
                    <div v-if="item.type == 'date'" class="date">
                      {{ item.date }}
                    </div>
                    <template v-if="item.role_type == 1">
                      <div class="box">
                        <div class="wrap-info">
                          <div class="message">
                            <div
                              v-html="item.content"
                              class="messageText"
                            ></div>
                            <div class="time">
                              {{
                                formatTimeZoneTime(item.create_date, "HH:mm")
                              }}
                            </div>
                          </div>
                        </div>
                        <img
                          @error="imgError($event)"
                          :src="user.head_img"
                          :alt="user.user_name"
                        />
                      </div>
                      <div style="clear: both"></div>
                    </template>
                    <template
                      v-if="item.role_type == 0 && item.parse_cate == 'z'"
                    >
                      <div class="box">
                        <img src="@/assets/img/robot.png" alt="" />
                        <div>
                          <div class="wrap-info">
                            <div class="message">
                              <div v-html="item.content"></div>
                              <div class="time">
                                {{
                                  formatTimeZoneTime(item.create_date, "HH:mm")
                                }}
                              </div>
                            </div>
                          </div>
                          <div
                            class="question-ext"
                            v-for="(ditem, dindex) in item.questionList"
                            :key="dindex"
                            @click="questionHandler(ditem.question)"
                          >
                            {{ ditem.question }}
                            <a-icon type="right" class="icon" />
                          </div>
                        </div>
                      </div>
                      <div style="clear: both"></div>
                    </template>
                    <template
                      v-if="item.role_type == 0 && item.parse_cate != 'z'"
                    >
                      <div class="box">
                        <img src="@/assets/img/robot.png" alt="" />
                        <div class="wrap-info">
                          <div class="message">
                            <div>
                              <div
                                class="answerContent"
                                v-html="item.answer_content"
                              ></div>
                              <div>
                                <span @click.stop="reviewHandler(item)"
                                  >review</span
                                >
                                {{ item.file_name }}
                              </div>
                            </div>
                            <div class="time">
                              {{
                                formatTimeZoneTime(item.create_date, "HH:mm")
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="clear: both"></div>
                    </template>
                  </li>

                  <li class="leftTalk" v-if="useWs && wsGetCont">
                    <div class="box">
                      <img src="@/assets/img/robot.png" alt="" />
                      <div class="wrap-info">
                        <div class="message thinking">
                          <div
                            class="rotationtiao_left"
                            style="margin-bottom: 10px"
                          >
                            <div class="gpt-flex-row">
                              <a-icon type="check" class="rightIcon" />
                              <div>{{ $t("thinking") }}</div>
                            </div>
                            <div
                              class="gpt-flex-row"
                              style="margin-bottom: 10px"
                            >
                              <a-icon type="check" class="rightIcon" />
                              <div class="newLine" style="width: 400px">
                                Start Answering: {{ content_chat }}
                              </div>
                            </div>
                            <div
                              id="messageContent"
                              class="messageContent"
                            ></div>
                            <!-- <div class="cursor-blink">&nbsp;</div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="leftTalk" v-if="sending">
                    <div class="box">
                      <img src="@/assets/img/robot.png" alt="" />
                      <div class="wrap-info">
                        <div class="message thinking">
                          <div class="text">thinking</div>
                          <div class="loading-chat">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="clear: both"></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </simplebar>
      </div>
      <div class="messageBox" ref="messageBox">
        <svg-icon iconClass="message" class="icon"></svg-icon>
        <div class="text" :class="{ noclick }">
          <a-input
            v-model="messageInfo"
            :placeholder="$t('Pleaseenteryourreply')"
            :autoSize="{ minRows: 2, maxRows: 10 }"
            style="overflow-y: auto"
            type="textarea"
            @input="changeHandler"
            class="textCont"
          ></a-input>
        </div>
        <a-icon
          @click="clearHandler"
          type="close-circle"
          style="margin-left: 10px; cursor: pointer"
        />
        <!-- <a-icon type="message" class="send" /> -->
        <span @click="sendHandler">
          <svg-icon
            v-if="!sending && !btn_loading"
            iconClass="send"
            class="send"
          ></svg-icon>
        </span>

        <span @click="redoHandler">
          <a-icon
            class="redo"
            v-if="!sending && !btn_loading && dialogList.length > 1"
            type="reload"
          />
        </span>

        <div
          class="sending"
          v-if="sending || btn_loading"
          :style="{ cursor: btn_loading ? 'pointer' : 'default' }"
          @click="stopAnswer"
        >
          <div class="circle"></div>
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
import simplebar from "simplebar-vue";
import "simplebar-vue/dist/simplebar.min.css";
import { debounce } from "@/utils/util";
import axios from "axios";
import { mapGetters } from "vuex";
import { EventSourcePolyfill } from "event-source-polyfill";
export default {
  data() {
    return {
      cancelSource: null,
      visible: false,
      // ws
      ws: null,
      // 打印机定时器
      PrintWords: null,
      btn_loading: false,
      //是否使用ws
      useWs: false,
      wsGetCont: false,
      contentList: [],
      //要回答的内容
      content_chat: "",
      //左侧最高高度
      maxLeftHeight: 400,
      //是否显示补充模板
      showTempList: false,
      // 模板列表
      tempList: [],
      //模板Id
      template_id: null,
      //正在发送中
      sending: false,
      //任务Id
      task_id: null,
      // 当前会话id
      session_id: null,
      //显示finish按钮
      showFinish: false,

      //显示更多
      showMore: false,
      //email taskID
      email_taskId: null,
      loading: false,
      startTalk: false,
      bottomHeight: 0,
      width: "800px",
      showSendEmail: false,
      /* 选中的引导数据*/
      selectedGuideDate: null,
      defaultImg: require("@/assets/img/avat.png"),
      //对话列表
      dialogList: [],
      inputData: "Enter your question here",
      /* 当为输入框的时候*/
      messageInfo: "",
      noclick: true,
      maxWindowHeight: 700,
      timer14: null,
      fromPath: "",
      initTips: "",
      hashObj: {},
      // 添加定时器管理数组
      timers: [],
    };
  },
  props: ["campaign_type", "campaign_id", "fromStep"],
  i18n: require("./i18n"),

  components: { simplebar },
  computed: {
    ...mapGetters("account", ["user"]),
  },
  beforeRouteEnter(to, from, next) {
    try {
      // `setPost` 方法定义在下面的代码中
      next((vm) => {
        vm.fromPath = from.path;
      });
    } catch (err) {
      // `setError` 方法定义在下面的代码中
      next((vm) => vm.setError(err));
    }
  },

  created() {
    this.getSessionId();
    this.loading = true;
    this.$axios(
      "/public/get_welcome_message",
      {
        campaign_id: parseInt(this.campaign_id),
      },
      "post"
    ).then((res) => {
      this.loading = false;
      if (res.code == 200) {
        this.initTips = res.data.message;
        console.log(res.data.message);
      }
    });
  },
  mounted() {
    this.resizeWindow2();
    window.addEventListener("resize", debounce(this.resizeWindow2, 300), false);
    // setTimeout(() => {
    //   //this.setScroll();
    // }, 200);
  },
  destroyed() {
    window.removeEventListener("resize", debounce(this.resizeWindow2, 300));
    this.closeWebSocket();
    this.loading = false;
    // 清理所有定时器
    this.clearAllTimers();
  },
  methods: {
    // 添加清理所有定时器的方法
    clearAllTimers() {
      // 清理 setInterval
      if (this.PrintWords) {
        clearInterval(this.PrintWords);
        this.PrintWords = null;
      }

      // 清理所有 setTimeout
      if (this.timers && this.timers.length > 0) {
        this.timers.forEach((timer) => {
          clearTimeout(timer);
        });
        this.timers = [];
      }

      // 清理特定的定时器
      if (this.timer14) {
        clearInterval(this.timer14);
        this.timer14 = null;
      }

      // 清理可能存在的其他定时器
      if (typeof this.heartbeatInterval !== "undefined") {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
      }
    },
    formatText(text) {
      const msg = text.replace(/\n/g, "<br>").replace(/\r/g, "<br>");
      return msg;
    },
    getSessionId() {
      this.$axios("/cms/random_session_id", {}, "post").then((res) => {
        if (res.code == 200) {
          this.session_id = res.data;
        }
      });
    },
    redoHandler() {
      this.dialogList = [];
      this.getSessionId();
    },
    publish() {
      let that = this;
      try {
        this.$confirm({
          title: this.$t("secondConfirm"),
          okText: this.$t("confirm"),
          cancelText: this.$t("cancel"),
          // content: h => <div style="color:red;">Some descriptions</div>,
          onOk() {
            that.loading = true;
            that.$emit("publishDirectly");
          },
          onCancel() {
            that.loading = false;
            console.log("Cancel");
          },
          class: "test",
        });
      } catch (error) {
        this.loading = false;
      }
    },
    backHandler() {
      this.$emit("backHandler", this.fromStep);
    },
    clearHandler() {
      if (this.noclick) {
        this.messageInfo = "";
      } else {
        this.inputData = "";
        this.noclick = true;
        this.selectedGuideDate = null;
      }
      // 使用定时器管理
      const timer = setTimeout(() => {
        this.resizeWindow2();
      }, 300);
      this.timers.push(timer);
    },
    async sendHandler() {
      let content = null;

      if (this.noclick && this.messageInfo) {
        content = this.messageInfo;
      }
      if (!content) {
        return;
      }
      this.dialogList.push({
        role_type: 1,
        content,
        create_date: Date.now(),
        parse_cate: "z",
      });
      this.startTalk = true;
      // 使用定时器管理
      const timer1 = setTimeout(() => {
        this.resizeWindow2();
        // 使用定时器管理
        const timer2 = setTimeout(() => {
          this.setScroll();
        }, 100);
        this.timers.push(timer2);
      }, 100);
      this.timers.push(timer1);

      if (this.inputData || this.messageInfo) {
        this.inputData = null;
        this.messageInfo = null;
        this.sending = true;
        let CancelToken = axios.CancelToken;
        // 创建一个CancelToken
        this.cancelSource = CancelToken.source();
        axios
          .post(
            "/cms/submit_question_campaign_simulation",
            {
              content,
              session_id: this.session_id,
              campaign_id: parseInt(this.campaign_id),
              campaign_type: this.campaign_type
                ? parseInt(this.campaign_type)
                : 1,
            },
            {
              cancelToken: this.cancelSource.token,
            }
          )
          .then((res) => {
            if (res.code == 200) {
              setTimeout(() => {
                this.setScroll();
              }, 100);
              if (res.data && res.data.msg) {
                this.sending = false;
                this.dialogList.push({
                  create_date: Date.now(),
                  role_type: 0,
                  content: res.data.msg,
                  parse_cate: "z",
                  questionList: [],
                });
                return;
              }
              this.btn_loading = true;

              this.contentList = [];
              const messageContent = document.getElementById("messageContent");
              if (messageContent) {
                messageContent.innerHTML = "";
              }

              this.dialogue({ useWs: true, content_chat: content });
            } else {
              this.sending = false;
            }
          })
          .catch((error) => {
            this.sending = false;
            if (axios.isCancel(error)) {
              console.log("Request canceled", error.message);
            } else {
              console.error("Error:", error);
            }
          });
      }
    },
    changeHandler() {
      // 使用定时器管理
      const timer = setTimeout(() => {
        this.resizeWindow2();
      }, 100);
      this.timers.push(timer);
    },
    setScroll() {
      var ele = document.querySelector(
        ".simplebarWrap-dialog .simplebar-content-wrapper"
      );
      if (!ele) {
        return;
      }
      var scrollHeight = ele.scrollHeight;
      ele.scrollTop = scrollHeight;
    },
    resizeWindow2() {
      var h =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.maxLeftHeight = h - 104 - 48 - 49 - 30 - 60 - 40;
      let width = document.body.clientWidth - 254 - 60 - 300 - 40 - 30 + "px";
      this.$set(this.$data, "width", width);
      var bottomHeight = document.querySelector(".bottom")
        ? document.querySelector(".bottom").clientHeight
        : 0;
      this.bottomHeight = bottomHeight;
      let dialogHeight = h - bottomHeight - 144 - 138 - 10 - 58;
      let messageBoxHeight = this.$refs["messageBox"]
        ? this.$refs["messageBox"].offsetHeight
        : 0;
      dialogHeight = dialogHeight - messageBoxHeight;
      this.maxWindowHeight = dialogHeight;
    },

    blurHandler(event) {
      if (event.target.nodeName == "INPUT") {
        let targetNode = event.target;
        if (targetNode.value) {
          event.target.previousElementSibling.innerText =
            "[" + targetNode.value + "]";
        } else {
          event.target.previousElementSibling.innerText =
            "[" + targetNode.getAttribute("origin-data") + "]";
        }

        event.target.previousElementSibling.style.display = "inline-block";
        event.target.style.display = "none";
        setTimeout(
          function (event1) {
            event1.target.parentNode.removeChild(event1.target);
          }.bind(this, event),
          300
        );
      }
    },
    onSend(value) {
      this.messages.push({
        sender: "user",
        content: value,
      });
      // Simulate AI response
      setTimeout(() => {
        this.messages.push({
          sender: "ai",
          content:
            "Thank you for your input. Here is your customized report...",
        });
      }, 1000);
    },
    //停止问答
    stopAnswer() {
      this.closeWebSocket();
    },
    skipConsultation() {},

    stopHeartbeat() {
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
      }
    },
    getAllMessage() {
      this.$axios(
        "/cms/get_message_content_by_reply_id",
        { reply_id: this.reply_id },
        "post"
      )
        .then((res) => {
          let { status, content } = res.data;
          const messageContent = document.getElementById("messageContent");
          if (res.code == 200 && status) {
            content = content.replace(/\n/g, "<br>");
            messageContent.innerHTML = content;
            this.setScroll();
            // 使用定时器管理
            const timer1 = setTimeout(() => {
              this.sending = false;
              this.contentList = [];
              let cont = this.makdownTohtml(messageContent.innerHTML);
              this.dialogList.push({
                create_date: Date.now(),
                role_type: 0,
                content: cont,
                parse_cate: "z",
                questionList: [],
              });
              this.useWs = false;
              this.wsGetCont = false;
              this.btn_loading = false;
              this.useWs = false;
              if (messageContent) {
                messageContent.innerHTML = "";
              }
              // 使用定时器管理
              const timer2 = setTimeout(() => {
                this.setScroll();
              }, 200);
              this.timers.push(timer2);
            }, 200);
            this.timers.push(timer1);
          } else if (res.code == 200 && !status) {
            this.getAllMessage();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async dialogue(data) {
      this.useWs = data.useWs;
      this.chat_reply = data;
      // 使用定时器管理
      const timer = setTimeout(() => {
        this.resizeWindow2();
      }, 100);
      this.timers.push(timer);
      // this.chatInfo.sessionId = data.sessionId;
      if (data.useWs) {
        // this.ws = new WebSocket(
        //   `${process.env.VUE_APP_API_WSS_URL}/cms/chat_campaign/${this.session_id}/${this.$route.query.campaign_id}`
        // );

        const token = localStorage.getItem("token");
        if (this.ws) {
          this.ws.close();
        }
        this.ws = new EventSourcePolyfill(
          `${process.env.VUE_APP_API_BASE_URL}cms/chat_campaign_sse/${this.session_id}/${this.$route.query.campaign_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "text/event-stream",
              timestamp: Date.now(),
            },
            heartbeatTimeout: 180000, // 比默认 45s 长，按需调整
          }
        );

        this.ws.addEventListener("ping", () => {
          console.log("SSE ping heartbeat received", new Date().toISOString());
        });
        //this.wsDate = this.getDate();

        this.ws.addEventListener("open", (event) => {
          console.log(event);
          // 启动心跳
          // this.startHeartbeat();
          this.ws_status = "open";
          // console.log(event.data)
          console.log("WebSocket 连接已建立");
          if (this.PrintWords) {
            return;
          }
          console.log("putContent");
          this.putContent();
          //写自己的逻辑
        });

        this.ws.addEventListener("message", (event) => {
          const returnData = JSON.parse(event.data);
          console.log("-----------------", returnData);
          this.reply_id = returnData.reply_id;
          if (returnData.message) {
            this.sending = false;
            this.wsGetCont = true;
          }

          console.log("----------");
          // console.log(returnData) //解析数据 返回格式 {"code": 200,"message": "工"}  code=200标识正常  非200代表异常 500是发生错误
          if (!this.hashObj[returnData.hash_id]) {
            this.hashObj[returnData.hash_id] = returnData.message;
            if (returnData.is_finished || returnData.message) {
              this.addMessageToList(returnData.is_finished, returnData.message);
            }
          }
        });

        this.ws.addEventListener("close", (event) => {
          this.sending = false;
          this.hashObj = {};
          // this.stopHeartbeat();
          this.ws_status = "close";
          // console.log(this.ws_status,'this.ws_status')
          console.log("WebSocket 连接已关闭"); //每次消息推流完成后，服务端都是主动断开websocket
          //this.btn_loading = false;
          this.noclick = true;
          if (event.code == 1006) {
            // 清理定时器
            if (this.timer14) {
              clearInterval(this.timer14);
            }
            if (this.PrintWords) {
              clearInterval(this.PrintWords);
              this.PrintWords = null;
            }

            this.getAllMessage();
          }

          // 确保定时器被清除
          if (this.PrintWords) {
            clearInterval(this.PrintWords);
            this.PrintWords = null;
          }
        });

        this.ws.addEventListener("error", (event) => {
          // this.ws_status = "error";
          // this.btn_loading = false;
          // this.noclick = true;
          // this.sending = false;
          console.error("WebSocket 连接错误：", event);
          // this.useWs = false;
          //写自己的逻辑
        });
      }
    },
    async addMessageToList(code, msg) {
      if (code == 1) {
        //当msg = [DONE]时代表流信息结束
        this.ws_status = "close";
        this.ws.close();
        // 正确清除定时器
        // if (this.PrintWords) {
        //   clearInterval(this.PrintWords);
        //   this.PrintWords = null;
        // }
        // console.log(this.ws_status,'DONE');
        return;
      }
      if (code == 0) {
        if (msg.includes("\n")) {
          //msg = '<br>';
          msg = msg.replace(/\n/g, "<br>");
        }
        this.contentList.push(msg);
      }
    },
    makdownTohtml(html) {
      const cont = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

      return cont;
    },
    imgError(e) {
      console.log(e.target.src);
      e.target.src = this.defaultImg;
    },
    putContent() {
      console.log("put content");
      // 彻底清理之前的定时器
      if (this.PrintWords) {
        clearInterval(this.PrintWords);
        this.PrintWords = null;
      }

      // 使用箭头函数避免this指向问题
      this.PrintWords = setInterval(() => {
        // 检查组件是否仍然存在
        if (!this._isDestroyed) {
          const messageContent = document.getElementById("messageContent");

          if (this.contentList.length && messageContent) {
            messageContent.innerHTML += this.contentList.shift();
            // 使用定时器管理
            const scrollTimer = setTimeout(() => {
              this.setScroll();
            }, 200);
            this.timers.push(scrollTimer);
          }

          console.log(
            "------this.contentList.length----",
            this.contentList.length
          );

          if (this.contentList.length == 0 && this.ws_status == "close") {
            // 不在定时器内部直接清除，而是设置标志位
            this.handleWebSocketClose();
          }
        }
      }, 100);
    },

    // 新增方法：处理WebSocket关闭逻辑
    handleWebSocketClose() {
      // 清理定时器
      if (this.PrintWords) {
        clearInterval(this.PrintWords);
        this.PrintWords = null;
      }

      this.sending = false;
      this.contentList = [];

      const messageContent = document.getElementById("messageContent");
      let cont = messageContent
        ? this.makdownTohtml(messageContent.innerHTML)
        : "";

      this.dialogList.push({
        create_date: Date.now(),
        role_type: 0,
        content: cont,
        parse_cate: "z",
        questionList: [],
      });

      this.useWs = false;
      this.btn_loading = false;
      this.useWs = false;

      if (messageContent) {
        messageContent.innerHTML = "";
      }

      this.wsGetCont = false;
      this.stopAnswer();

      // 使用定时器管理
      const scrollTimer = setTimeout(() => {
        this.setScroll();
      }, 200);
      this.timers.push(scrollTimer);
    },
    //关闭websocket
    closeWebSocket() {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
        this.useWs = false;
        this.btn_loading = false;
        this.sending = false;
        this.ws_status = "close";
      }

      if (this.sending) {
        this.btn_loading = false;
        this.sending = false;
        if (this.cancelSource) {
          this.cancelSource.cancel("Operation canceled by the user.");
        }
      }

      // 彻底清理定时器
      if (this.PrintWords) {
        clearInterval(this.PrintWords);
        this.PrintWords = null;
      }

      if (this.timer14) {
        clearInterval(this.timer14);
        this.timer14 = null;
      }

      // 清理可能存在的其他定时器
      if (typeof this.heartbeatInterval !== "undefined") {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.main-box {
  // padding: 20px 30px;
  display: flex;
  flex-flow: column;
}
.header {
  text-align: center;
  margin-bottom: 20px;
  position: relative;
  .backer {
    font-size: 16px;
    position: absolute;
    color: #0e756a;
    cursor: pointer;
    left: 0;
    top: 16px;
    .icon {
      margin-right: 3px;
    }
  }
  .publish {
    position: absolute;
    right: 0;
    top: 16px;
  }
  .title {
    font-size: 24px;
    margin: 0 0 10px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    .icon {
      margin-right: 5px;
      font-size: 24px;
      color: #0e756a;
    }
  }

  .subtitle {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.52);
  }
}
.dialogWind {
  background: #eee;
  border-radius: 8px;
  padding: 0 10px;
}
.talkWind {
  .wrap-message {
    margin-top: 30px;
    // padding: 30px 30px 30px 30px;

    li {
      // margin-bottom: 30px;
      .box {
        box-sizing: border-box;
        width: 668px;
        display: flex;
        align-items: top;
        border-radius: 4px;
        display: flex;
        align-items: top;
        img {
          width: 57px;
          height: 57px;
          border-radius: 50%;
        }
        .message {
          font-family: Arial, Arial;
          font-weight: 400;
          font-size: 16px;
          color: #36384d;
          line-height: 24px;
          margin-bottom: 30px;
          .messageText::selection {
            text-decoration: none;
          }
          .answerContent {
            margin-bottom: 10px;
          }
          .time {
            margin-top: 18px;
            color: #fff;
            font-weight: bold;
            font-size: 16px;
          }
        }
        .gpt-flex-row {
          display: flex;
          align-items: center;
        }
        .messageContent::after {
          content: "|";
          animation: blink 1s infinite;
        }
        @keyframes blink {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .rightIcon {
          color: #0e756a;
          margin-right: 10px;
        }
        .newline {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .name {
          font-family: Arial, Arial;
          font-weight: bold;
          font-size: 18px;
        }
      }
      .date {
        color: #80829f;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 32px;
      }
    }

    .leftTalk {
      position: relative;
      .box {
        // background: #eeeff6;

        .wrap-info {
          margin-left: 18px;
          span {
            display: inline-block;
            color: #ffffff;
            background: #0e756a;
            border-radius: 4px 4px 4px 4px;
            padding: 6px 11px;
            font-size: 16px;
            cursor: pointer;
          }
        }
        .question-ext {
          font-weight: bold;
          font-size: 16px;
          color: #0e756a;
          font-weight: bold;
          font-size: 16px;
          color: #0e756a;
          padding: 20px 30px;
          background: #fff;
          max-width: 400px;
          border-radius: 0px 10px 10px 10px;
          cursor: pointer;
          margin-left: 18px;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .icon {
            margin-left: 12px;
            color: #0e756a;
            font-size: 12px;
          }
        }
        .message {
          color: #000;
          background: #ffffff;
          border-radius: 0px 10px 10px 10px;
          padding: 20px 30px 14px 30px;
          margin-bottom: 30px;
          .time {
            text-align: left;
            color: #000;
          }
        }
        .name {
          color: #000000;
        }
      }
    }
    .rightTalk {
      position: relative;
      .box {
        // background: #0e756a;
        justify-content: right;
        float: right;
        .wrap-info {
          margin-right: 18px;
          // width: 542px;
        }
        .message {
          color: #bcdeda;
          background: linear-gradient(268deg, #1c746b 0%, #1b8176 100%);
          border-radius: 10px 0px 10px 10px;
          padding: 30px 30px 10px 30px;
        }
        .name {
          color: #fff;
          text-align: right;
        }
      }
      .box::after {
        content: "";
        clear: both;
      }
      .time {
        text-align: right;
        color: #ffffff;
      }
    }
  }
}

.messageBox {
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d9dfe9;
  display: flex;
  padding: 12px 29px 12px 12px;
  margin-top: 10px;
  margin-bottom: 20px;
  // height: 70px;
  align-items: center;
  .icon {
    font-size: 24px;
    margin-right: 26px;
  }
  .text {
    width: 100%;
    flex: 1;
    // height: 70px;
    overflow-y: auto;
    // padding: 12px 0;
    .textCont {
      // height: 46px;
      overflow-y: auto;
      border: none;
      box-shadow: none;
      // min-height: 50px;
      overflow: auto;
      resize: none;
      /deep/span {
        display: inline-block;
        color: #0e756a;
        cursor: pointer;
      }
      /deep/input {
        border: none;
        border-bottom: 1px solid #000;
        outline: none;
      }
      /deep/input:focus,
      input:active {
        box-shadow: none;
      }
    }
    // display: flex;
    // align-items: center;
  }
  .noclick {
    color: #bec0d5;
    font-size: 16px;
  }
  .send {
    font-size: 32px;
    margin-left: 20px;
    cursor: pointer;
  }
  .sending {
    margin-left: 20px;
    width: 32px;
    border: #ff6a6a solid 4px;
    position: relative;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    .circle {
      width: 12px;
      height: 12px;
      background: #ff6a6a;
      border-radius: 3px;
    }
  }
}
.simplebarWrapLeft {
  width: 242px;
  /deep/.simplebar-scrollbar:before {
    background: #0e756a;
  }
}
.simplebarWrap {
  /deep/.simplebar-scrollbar:before {
    background: #0e756a;
  }
  /* 定制滚动条轨道 */
  .simplebar-track.simplebar-vertical {
    width: 10px; /* 设置宽度 */
  }

  /* 定制滚动条滑块 */
  .simplebar-scrollbar.simplebar-vertical .simplebar-thumb {
    width: 10px; /* 设置滑块宽度 */
    background-color: red; /* 设置滑块颜色 */
    border-radius: 10px; /* 设置滑块圆角 */
  }

  /* 定制滚动条轨道和滑块的交界处 */
  .simplebar-track.simplebar-vertical .simplebar-scrollbar {
    border-radius: 10px; /* 设置圆角 */
  }
}
.wrap-btn {
  padding: 20px 0;
  text-align: center;
  .ant-btn {
    margin: 0 10px;
  }
}
.redo {
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  margin-left: 12px;
}

/**chatloading */
.loading_chat,
.loading-chat > div {
  position: relative;
  box-sizing: border-box;
}

.loading-chat {
  display: block;
  font-size: 0;
  color: #0e756a;
}

.loading-chat.la-dark {
  color: #333;
}

.loading-chat > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.loading-chat {
  width: 64px;
  height: 18px;
}

.loading-chat > div:nth-child(1) {
  animation-delay: -200ms;
}

.loading-chat > div:nth-child(2) {
  animation-delay: -100ms;
}

.loading-chat > div:nth-child(3) {
  animation-delay: 0ms;
}

.loading-chat > div {
  width: 10px;
  height: 10px;
  margin: 4px;
  border-radius: 100%;
  animation: ball-pulse 1s ease infinite;
}

.loading-chat.la-sm {
  width: 26px;
  height: 8px;
}

.loading-chat.la-sm > div {
  width: 4px;
  height: 4px;
  margin: 2px;
}

.loading-chat.la-2x {
  width: 108px;
  height: 36px;
}

.loading-chat.la-2x > div {
  width: 20px;
  height: 20px;
  margin: 8px;
}

.loading-chat.la-3x {
  width: 162px;
  height: 54px;
}

.loading-chat.la-3x > div {
  width: 30px;
  height: 30px;
  margin: 12px;
}

@keyframes ball-pulse {
  0%,
  60%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  30% {
    opacity: 0.1;
    transform: scale(0.01);
  }
}
.loading-link {
  position: relative;
  width: 15px;
  height: 15px;
  border: 2px solid #666;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;

  animation: circle infinite 0.75s linear;
}

@keyframes circle {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.thinking {
  display: flex;
  align-items: center;
  .text {
    margin-right: 10px;
  }
}
</style>
